import React from 'react';
import MUIDataTable from "mui-datatables";
import { GET } from "../../../queries/user";
import Delete from './delete';
import { graphql } from 'react-apollo';
import DrawerPlacements from '../../../components/DrawerPlacements';
import { Grid } from '@material-ui/core';
import PageError from '../../../components/PageError';
import PageLoading from '../../../components/PageLoading';
import PageTitle from "../../../components/PageTitle/PageTitle";
import AddUsers from '../../../pages/users/actions/create';
import UpdateUsers from '../../../pages/users/actions/edit';

const usersFunc = ({ data: { users, loading, error }}) => {
  const options = {
    selectableRows: 'checkbox',
    responsive: "scrollMaxHeight",
    customToolbarSelect: selectedRows => (
      <Delete selectedRows = {selectedRows} users={users}/>
    )
  };

  const ActionsRow = (tableMeta) => {
    const id = tableMeta.rowData[1];
    const name = tableMeta.rowData[0];
    const email = tableMeta.rowData[2];
    const password = tableMeta.rowData[3];
    const role = tableMeta.rowData[4];
    const owner = tableMeta.rowData[5];
    return (
      <Grid container spacing={0}>
        <Grid item xs={6}>
        <DrawerPlacements title="Edit User" iconButtonAction={false} labeButtonAction={name}>
        <UpdateUsers id = {id} name = {name} email = {email} password = {password} role = {role} owner={owner}></UpdateUsers>
        </DrawerPlacements>

        </Grid>
        <Grid item xs={6}>
        </Grid>
      </Grid>
    );
  };
  return (
    <>
      <Grid container spacing={0}>
        <Grid item xs={10}>
          <PageTitle title="Users"/>
        </Grid>
        <Grid item xs={2}>
          <DrawerPlacements title="User" labeButtonAction="Add">
            <AddUsers></AddUsers>
          </DrawerPlacements>
        </Grid>
      </Grid>
      
      {
        (loading) ? <PageLoading /> : 
        (error) ? <PageError /> :
        (
          <Grid container spacing={4}>
            <Grid item xs={12}>
              <MUIDataTable
                title={false}
                data={users}
                columns={[
                  {
                    label : 'Name',
                    name  : 'name',
                    options: {
                      customBodyRender : (value, tableMeta, updateValue) => { 
                        return (ActionsRow(tableMeta))
                      },
                      empty  : true,
                      filter : true,
                      sort   : true,
                    }
                  },{
                    name    : 'id',
                    options : {
                      display : false
                    }
                  },
                  {
                    label : 'Email',
                    name  : 'email',
                  },
                  {
                    name    : 'password',
                    options : {
                      display : false
                    }
                  },{
                    name    : 'role',
                    options : {
                      display : true
                    }
                  },
                  {
                    name    : 'owner',
                    options : {
                      display : false
                    }
                  }
                ]}
                options={options}
              />
            </Grid>
          </Grid>
        )
      }
  </>);
}

export const Users = graphql(GET)(usersFunc);